import { ChangeDetectorRef, Directive, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { TabService } from './tab.service';

@Directive({
    selector: '[appEnterExe]',
})

export class EnterExeDirective implements OnInit{
    @Input() lastIndex: any;
    @Output() callbackFunction: EventEmitter<any> = new EventEmitter();
    constructor (
        private tabService: TabService,
        private cdr: ChangeDetectorRef,
    ) {

    }
  ngOnInit(): void {
  }

    @HostListener('keydown', ['$event'])  onInput(e: any){
        if(e.which === 13){
          e.preventDefault();
        }      
      }
}